import { render, staticRenderFns } from "./PerfilDropdown.vue?vue&type=template&id=d499d006&scoped=true&"
import script from "./PerfilDropdown.vue?vue&type=script&lang=js&"
export * from "./PerfilDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PerfilDropdown.vue?vue&type=style&index=0&id=d499d006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d499d006",
  null
  
)

export default component.exports